<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_toc_1"><span>The Secret of the Sheikh’s Betrothed</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By Felicitas Ivey</p>
<p class="P_Normal"> </p>
<p class="P_Normal">A billionaire and a Bedouin girl—each with a shocking secret.</p>
<p class="P_Normal">Billionaire Fathi al-Murzim is a workaholic businessman, too busy running the family’s companies to even think about marriage. Too bad he never told his grandfather he’s gay, because Grandfather just announced a childhood betrothal—to a Bedouin girl Fathi never heard about before.</p>
<p class="P_Normal">Ikraam din Abdel was raised as a woman by his avaricious and abusive older sister, who didn’t want him to be their father’s heir. He’d never thought to be married either, and is surprised when his sister informs him of his betrothal.</p>
<p class="P_Normal">When Fathi and Ikraam meet, they are drawn to each other in a manner neither of them expected. As the plans for their wedding progress, they both realize they need to tell the other the truth. But can they, with both cultural taboos and family pressures to deal with?</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?5a15c51c